import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Leaf, ArrowRight, BadgeCheck } from "lucide-react";
import { ORGANIC_CATS } from "@/components/OrganicBadge";

const IMG = "https://images.unsplash.com/photo-1707721690544-781fe6ede937?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";

const OrganicBanner = () => {
  const { t, lang } = useApp();
  const hi = lang === "hi";
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-testid="organic-banner">
      <div className="relative overflow-hidden rounded-2xl bg-[#14532D] text-white grid md:grid-cols-5">
        <div className="absolute inset-0 leaf-pattern opacity-10 pointer-events-none" />
        <div className="relative md:col-span-3 p-6 sm:p-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest bg-white/15 rounded-full px-3 py-1">
            <BadgeCheck className="w-3.5 h-3.5" /> {hi ? "प्रमाणित जैविक" : "Certified Organic"}
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-4 font-devanagari" data-testid="organic-banner-title">
            जैविक खेती {!hi && <span className="block text-xl sm:text-2xl font-semibold text-green-200 mt-1">Organic Farming</span>}
          </h2>
          <p className={`mt-3 text-green-100 text-sm sm:text-base max-w-md ${hi ? "font-devanagari" : ""}`}>
            {hi
              ? "रसायन-मुक्त कीटनाशक, जैविक कृषि उत्पाद और अवशेष-मुक्त उपज — मिट्टी और सेहत दोनों के लिए बेहतर।"
              : "Chemical-free pesticides, organic agro products and residue-free produce — better for soil and health."}
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {ORGANIC_CATS.map((c) => (
              <Link
                key={c}
                to={`/products?category=${c}`}
                data-testid={`organic-banner-link-${c}`}
                className="group inline-flex items-center gap-1.5 rounded-full bg-white text-[#14532D] px-4 py-2 text-sm font-semibold hover:bg-green-100 transition-colors"
              >
                <Leaf className="w-4 h-4" /> {t(c)}
                <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
              </Link>
            ))}
          </div>
        </div>
        <div className="relative md:col-span-2 min-h-[200px]">
          <img src={IMG} alt="Organic farming" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#14532D] via-[#14532D]/30 to-transparent md:block hidden" />
        </div>
      </div>
    </section>
  );
};

export default OrganicBanner;
